export function getPromoCodeValueFromQueryParams() {
  const queryParams = (window.location.search).split('&');
  const promoCodeParam = queryParams.find(p => p.includes('promoCode'));
  return promoCodeParam ? promoCodeParam.split('=')[1] : null;
}
